import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js';
import textTemplate from 'properties/main/text.ejs';
import eventBus         from 'EventBus.js';
import util     from 'util/Util.js';
import textUtil from 'util/TextUtil.js';
import constants        from 'Constants.js';
import mobileSyncService from "../../service/mobile/MobileSyncService";

class MainTextView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = textTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.selectedColor = 'lightgrey';
        this.unselectedColor = 'transparent';


        this.events = {
            'change textarea, input[type=text]' : 'updateAttributes',
            'blur textarea, input[type=text]'   : 'lostFocus',
            'focus textarea, input[type=text]'   : 'getFocus',
            'click img' : 'updateImgAttributes',
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        // Add needed property
        if (this.model.get('text') === undefined) {
            if (this.model.get('factoryKey') !== 'control_text_input' &&
                this.model.get('factoryKey') !== 'control_multiple_text_input') {
                    this.model.set('text', 'Text', constants.MODEL_SILENT);
            }
        }
        if (!this.model.get('align')) {
            this.model.set('align', 'left', constants.MODEL_SILENT);
        }
        if (!this.model.get('isHtml')) {
            this.model.set('isHtml', 'false', constants.MODEL_SILENT);
        }

        this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
        this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
        this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);

        switch  (this.model.get('align')) {
            case 'left':
                this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
                break;
            case 'center':
                this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
                break;
            case 'right':
                this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
                break;
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(textUtil.replaceNewLinesWithCarriageReturns(ev.currentTarget.value), true, this.model.get(propName), util.isTrue(this.model.get("isHtml")));

        if(propName === "text"){
            textUtil.adjustTextWidth(this.model, propVal);
        }

        this.model.set( propName, propVal );
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });

        if (this.model.get('factoryKey') === 'control_text_input') {
            eventBus.trigger('validateTextValue', ev);
        }
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        this.model.set( propName, propVal );
        mobileSyncService.synchronize(this.model, {key: propName, val: propVal });
    }

    updateImgAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        //const propVal  = ev.currentTarget.value;
        let newValue = "left";
        this.model.set('alignLeftSelection', this.unselectedColor, constants.MODEL_SILENT);
        this.model.set('alignCenterSelection', this.unselectedColor, constants.MODEL_SILENT);
        this.model.set('alignRightSelection', this.unselectedColor, constants.MODEL_SILENT);
        mobileSyncService.synchronize(this.model, {key: 'alignLeftSelection', val: this.unselectedColor });
        mobileSyncService.synchronize(this.model, {key: 'alignCenterSelection', val: this.unselectedColor });
        mobileSyncService.synchronize(this.model, {key: 'alignRightSelection', val: this.unselectedColor });
        
        if (propName === "align-center") {
            newValue = "center";
            this.model.set('alignCenterSelection', this.selectedColor, constants.MODEL_SILENT);
            mobileSyncService.synchronize(this.model, {key: 'alignCenterSelection', val: this.selectedColor });
        } else if (propName === "align-right") {
            newValue = "right";
            this.model.set('alignRightSelection', this.selectedColor, constants.MODEL_SILENT);
            mobileSyncService.synchronize(this.model, {key: 'alignRightSelection', val: this.selectedColor });
        }
        else {
            this.model.set('alignLeftSelection', this.selectedColor, constants.MODEL_SILENT);
            mobileSyncService.synchronize(this.model, {key: 'alignLeftSelection', val: this.selectedColor });
        }
        this.model.set( 'align', newValue );
        mobileSyncService.synchronize(this.model, {key: 'align', val: newValue });
    }


    render() {
        this.model.set('hideAlignment', (this.model.get('hideAlignmentSection') ? 'hidden' : ''), constants.MODEL_SILENT);

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.model.get('factoryKey') === 'control_text_input' ||
            this.model.get('factoryKey') === 'control_multiple_text_input') {
            $('#propTextHTML').addClass('hide');            
        }

        if (this.model.get('factoryKey') === 'control_multiple_text_input') {
            $('#textMultiline').text(this.model.get('text'));
        }

        let isHtml = util.isTrue(this.model.get('isHtml'));
        $(`input[name='isHtml']`).prop('checked', isHtml );

        this.addMultilanguageIcon();

        this.delegateEvents();
        return this;
    }


}

export default MainTextView;
